class GroupedSimulationDataModelsController {
    constructor($scope) {
        this.$onInit = () => {
            this.init();
        };
        this.init = () => {
            this.state = {
                groupTitle: !_.isNil(this.groupTitle) ? this.groupTitle : 'Simulation Data Models',
                modelNameFilter: '',
                selectedModel: null,
                versionFilter: !_.isNil(this.versionFilter) ? this.versionFilter : '',
                versionFilterActive: false,
                displayVersion: this.displayVersion
            };
            if (this.state.versionFilter.length > 0) {
                this.state.versionFilterActive = true;
            }
            this.$scope.$watchCollection(() => this.simulationDataModels, (newModels) => {
                this.groupedDataModels = this.buildGroupedDataModels(newModels);
                this.selectModel(null);
            });
        };
        this.buildGroupedDataModels = (models) => {
            let types = this.getUniqueDataTypesFromModels(models);
            let listItems = [];
            angular.forEach(types, (type, key) => {
                // If we're filtering on the version and the versions don't match then don't bother adding the type
                if (this.state.versionFilterActive) {
                    if (type.Version !== this.state.versionFilter) {
                        return;
                    }
                }
                let group = {
                    type: type,
                    models: []
                };
                group.models = _.filter(models, (model) => {
                    return type.Id === model.SimulationDataType.Id;
                });
                // Only add it if it has children
                if (group.models.length > 0) {
                    listItems.push(group);
                }
            });
            return listItems;
        };
        this.getUniqueDataTypesFromModels = (models) => {
            let types = [];
            angular.forEach(models, (model, key) => {
                let typeAdded = _.some(types, (type) => {
                    return type.Id === model.SimulationDataType.Id;
                });
                if (!typeAdded) {
                    types.push(model.SimulationDataType);
                }
            });
            return types;
        };
        this.selectModel = (model) => {
            this.state.selectedModel = model;
            if (!_.isNil(model) && !_.isNil(this.selectedModelChanged)) {
                this.selectedModelChanged(model);
            }
        };
        this.swapVersionFilterActive = () => {
            this.state.versionFilterActive = !this.state.versionFilterActive;
            this.groupedDataModels = this.buildGroupedDataModels(this.simulationDataModels);
            this.selectModel(null);
        };
        this.$scope = $scope;
    }
}
angular.module('app').component('groupedSimulationDataModels', {
    bindings: {
        groupTitle: '@',
        groupBy: '@',
        simulationDataModels: '<',
        showSpinner: '<',
        selectedModelChanged: '<',
        versionFilter: '<?',
        displayVersion: '<?'
    },
    transclude: true,
    templateUrl: 'scripts/app/components/grouped-simulation-data-models/grouped-simulation-data-models.tpl.html',
    controllerAs: 'vm',
    controller: GroupedSimulationDataModelsController
});
